interface NavigatorData {
  [key: string]: string
}

// Method to extract browser navigator data
function getBrowserData(): NavigatorData | undefined {
  if (undefined === window) return
  if (undefined === window.navigator) return

  const navigatorKeys = [
    "appCodeName",
    "appName",
    "appVersion",
    "platform",
    "product",
    "productSub",
    "userAgent",
    "vendor",
    "vendorSub",
    "language",
    "languages",
  ]

  const data: NavigatorData = {}

  navigatorKeys.map(key => {
    //@ts-ignore navigator does not have key string
    const navData = window.navigator[key]
    if (undefined !== navData) {
      data[key] = navData
    }
  })

  return data
}

export default getBrowserData
